import type { SVGProps } from "react";
const SvgSearch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m11.667 11.667 2.083 2.083"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.25}
      d="M13.694 15.438a1.233 1.233 0 0 1 1.744-1.744l2.534 2.535a1.233 1.233 0 1 1-1.743 1.743z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M13.333 7.5a5.833 5.833 0 1 0-11.666 0 5.833 5.833 0 0 0 11.666 0Z"
    />
  </svg>
);
export default SvgSearch02;
